export default "__VITE_ASSET__CKDp1kY1__"